export const normalizeSendNumber = (value: string) => value.replace(/\D/g, '');

export const isSendPhoneNumber = (value: string) => /^[0-9]{8,15}$/.test(normalizeSendNumber(value));

export const areSendVariablesFilled = (names: string[], values: Record<string, string>) =>
  names.every(name => Boolean(values[name]?.trim()));
